export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10802.b7593188.jpg";